import { createStart, createMiddleware } from "@tanstack/react-start";
import * as Sentry from "@sentry/cloudflare";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";
// Sentry is initialized by `withSentry(...)` in src/server.ts (Cloudflare
// Worker runtime). Middleware here just calls captureException.

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    try { Sentry.captureException(error); } catch { /* noop */ }
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// Capture server-function errors (RPC failures) without altering business logic.
const sentryFnMiddleware = createMiddleware({ type: "function" }).server(
  async ({ next }) => {
    try {
      return await next();
    } catch (error) {
      try { Sentry.captureException(error); } catch { /* noop */ }
      throw error;
    }
  },
);


export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth, sentryFnMiddleware],
  requestMiddleware: [errorMiddleware],
}));
